const shortCodeColor = {
  coal: '#b47836',
  gas: '#808080',
  oil: '#000000',
  biomass: '#6fc22f',
  solar: '#c7af2e',
  wind: '#00a2d2',
  geothermal_heat: '#887400',
  electricity: '#ffd360',
  oil_products: '#333333',
  solar_heat: '#c7af2e',
  heat: '#7030a0',
  nuclear: '#ec6625',
  renewables: '#887400',
  non_renewables: '#8d7979',
  others: '#8d7979',
  industry: '#004a5b',
  tertiary: '#008aa9',
  transport: '#5be1ff',
  h2: '#D4E9F5'
}

function getShortCodeForSerieCode (code) {
  let shortTitle = code
  const matchShortTitles = [
    { key: 'INDUS', value: 'industry' },
    { key: 'RASS', value: 'tertiary' },
    { key: 'TRANS', value: 'transport' },
    { key: 'OIL', value: 'oil' },
    { key: 'COAL', value: 'coal' },
    { key: 'HEA', value: 'heat' },
    { key: 'H2', value: 'h2' },
    { key: 'ELE', value: 'electricity' },
    { key: 'BIO', value: 'biomass' },
    { key: 'GAS', value: 'gas' },
    { key: 'NUT', value: 'nuclear' },
    { key: 'REN', value: 'renewables' }
  ]
  matchShortTitles.forEach((matchShortTitle) => {
    if (code.search(matchShortTitle.key) > -1 && shortTitle === code) {
      shortTitle = matchShortTitle.value
    }
  })
  return shortTitle
  // if (code.search('OIL') > 0) {
  //   return 'oil'
  // } else if (code.search('OIL') > 0) {
  //   return 'oil'
  // }
  // switch (code) {
  //   case 'elccfind': return 'industry'
  //   case 'elccfret': return 'tertiary'
  //   case 'elccftra': return 'transport'
  //   case 'calc_othcfven': return 'heat'
  //   case (code.search('OIL') > 0): return 'oil'
  //   default :
  //     switch (code.substr(0, 3)) {
  //       case 'pet' : return 'oil'
  //       case 'etp' : return 'oil'
  //       case 'ept' : return 'gas'
  //       case 'cms' : return 'coal'
  //       case 'etc' : return 'coal'
  //       case 'ecm' : return 'coal'
  //       case 'gna' : return 'gas'
  //       case 'gaz' : return 'gas'
  //       case 'etg' : return 'gas'
  //       case 'egn' : return 'gas'
  //       case 'elc' : return 'electricity'
  //       case 'enc' : return 'biomass'
  //       case 'enu' : return 'nuclear'
  //       case 'enr' : return 'renewables'
  //       case 'co2' :
  //         switch (code.substr(-3)) {
  //           case 'pet' : return 'oil'
  //           case 'cms' : return 'coal'
  //           case 'gaz' : return 'gas'
  //         }
  //         break
  //       default :
  //         switch (code.substr(-3)) {
  //           case 'ren' : return 'renewables'
  //         }
  //         break
  //     }
  // }
  // return code
}

function getColorForSerieCode (code) {
  const shortCode = getShortCodeForSerieCode(code)
  if (shortCode in shortCodeColor) {
    return shortCodeColor[shortCode]
  }
  return '#FF0000'
}

export { getShortCodeForSerieCode, getColorForSerieCode }
